<template>
  <div
    class="check-list-phone auto-list_col_centered price-load-day"
    @click.stop
  >
    <el-row type="flex" align="middle" justify="center">
      <div class="fs-14">
        <p v-if="type !== 'harvest'">
          {{ response.price_from_storage | getPrice }}
          <span v-if="type === 'harvest_or_delivery'"> (П), </span>
        </p>
        <p v-if="type !== 'delivery'">
          {{ response.price_from_field | getPrice }}
          <span v-if="type === 'harvest_or_delivery'"> (У) </span>
        </p>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'PriceInProgress',
  props: {
    response: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
  },
}
</script>
